import React from 'react';

export default function ToggleBar({ activeTab, onTabChange }) {
  const tabs = [
    { id: 'profile', label: 'プロフィール' },
    { id: 'mynote', label: 'Myノート' },
    { id: 'recruit', label: '募集一覧' },
  ];

  return (
    <div className="container mt-4 d-flex justify-content-center align-items-center">
      <div className="col-lg-8 toggle-bar d-flex justify-content-center align-items-center">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`btn btn-toggle ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
